import type { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/router";

import Loading from "lib/components/CenterLoading";
import type { HelpPostProps } from "lib/components/help/Help";
import Help from "lib/components/help/Help";
import Page404 from "pages/404";

const Content = (attrbts: HelpPostProps) => {
  const router = useRouter();

  // Display loading until `getStaticProps()` finishes running, and populates the props.
  if (router.isFallback) {
    return <Loading />;
  }

  // If attributes are not populated, return an empty object.
  if ("error" in attrbts) {
    return <Page404 />;
  }

  return <Help {...attrbts} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/items/help/`
  );
  const posts = await res.json();

  const paths = posts.data.map((post: { slug: string }) => {
    return { params: { slug: post.slug } };
  });

  return {
    paths,
    fallback: true,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/items/help?filter[slug][_eq]=${params?.slug}`
  );
  const post = await res.json();

  if (post.data && post.data.length === 1) {
    return {
      props: post.data[0],
      revalidate: 10,
    };
  }
  return {
    props: { error: "Post not found" },
    revalidate: 10,
  };
};

export default Content;
